module.exports = __webpack_public_path__ + "img/16581256_S.6cf7a972.png";